import { func, string } from 'prop-types';
import { Field, Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { intlShape, injectIntl } from '../../../../util/reactIntl';
import {
  Button,
  FieldLocationAutocompleteInput,
  FieldTextInput,
  Form,
  Icons,
} from '../../../../components';
import css from './LandingSearchForm.module.css';
import IconSearchDesktop from '../../../NotFoundPage/SearchForm/IconSearchDesktop';
import { SearchType } from '../../../../util/enums';
import { SEARCH_TYPE_OPTIONS } from '../../../../config/configSearch';
import { isMobileViewport } from '../../../../util/viewport';

const identity = v => v;

const LandingSearchFormComponent = props => {
  const {
    viewport,
    onSubmit,
    submitInProgress,
    rootClassName,
    className,
    intl,
    isSearchPageFilter,
    isMobileSearch,
  } = props;
  const isMobileLayout = isMobileSearch || isMobileViewport(viewport);

  return (
    <FinalForm
      {...props}
      initialValues={
        props.initialValues || {
          searchType: SearchType.LOCATION,
        }
      }
      render={formRenderProps => {
        const { values, handleSubmit, form } = formRenderProps;
        const classes = classNames(rootClassName || css.root, className, {
          [css.searchPageFilter]: isSearchPageFilter,
          [css.mobileSearch]: isMobileSearch,
        });
        const { searchType } = values || {};

        const handlePlaceSelect = place => {
          form.change('location', {
            search: place.address || place.description,
            selectedPlace: place,
          });
          form.submit();
        };

        const handleSearchTypeChange = newSearchType => {
          form.change('searchType', newSearchType);
        };

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            {isMobileLayout ? (
              <div className={css.mobileSearchWrapper}>
                <div className={css.mobileSearchHeader}>
                  <h2>
                    {intl.formatMessage({
                      id: 'LandingSearchForm.where',
                    })}
                  </h2>
                </div>
                <div className={css.searchType}>
                  {SEARCH_TYPE_OPTIONS.map(({ value, messageId }) => (
                    <div
                      className={classNames(
                        css.searchTypeTab,
                        searchType === value ? css.activeTab : null
                      )}
                      key={value}
                      onClick={() => handleSearchTypeChange(value)}
                    >
                      {value === 'keywords' ? (
                        <Icons name="keywordSearch" />
                      ) : (
                        <Icons name="locationSearch" />
                      )}
                      <h2>
                        {intl.formatMessage({
                          id: messageId,
                        })}
                      </h2>
                      <p>
                        {intl.formatMessage({
                          id: 'LandingSearchForm.popularHint',
                        })}
                      </p>
                    </div>
                  ))}
                </div>
                {searchType === SearchType.LOCATION && (
                  <FieldLocationAutocompleteInput
                    rootClassName={css.locationAddress}
                    inputClassName={css.locationAutocompleteInput}
                    iconClassName={css.locationAutocompleteInputIcon}
                    predictionsClassName={css.predictionsRoot}
                    validClassName={css.validLocation}
                    name="location"
                    label=""
                    placeholder={intl.formatMessage({
                      id: 'LandingSearchForm.locationPlaceholder',
                    })}
                    useDefaultPredictions={true}
                    format={identity}
                    valueFromForm={values.location}
                    onChange={value => {
                      form.change('location', value);
                    }}
                    onPlaceSelected={handlePlaceSelect}
                  />
                )}
                {searchType === SearchType.KEYWORDS && (
                  <FieldTextInput
                    type="text"
                    className={css.keywordsInput}
                    id="keywords"
                    name="keywords"
                    placeholder={intl.formatMessage({
                      id: 'LandingSearchForm.keywordsPlaceholder',
                    })}
                  />
                )}
              </div>
            ) : (
              <Field name="searchType" component="select" className={css.searchTypeSelector}>
                {SEARCH_TYPE_OPTIONS.map(({ value, messageId }) => (
                  <option key={value} value={value}>
                    {intl.formatMessage({
                      id: messageId,
                    })}
                  </option>
                ))}
              </Field>
            )}
            {!isMobileLayout ? (
              <>
                {searchType === SearchType.LOCATION && (
                  <FieldLocationAutocompleteInput
                    rootClassName={css.locationAddress}
                    inputClassName={css.locationAutocompleteInput}
                    iconClassName={css.locationAutocompleteInputIcon}
                    predictionsClassName={css.predictionsRoot}
                    validClassName={css.validLocation}
                    name="location"
                    label=""
                    placeholder={intl.formatMessage({
                      id: 'LandingSearchForm.locationPlaceholder',
                    })}
                    useDefaultPredictions={true}
                    format={identity}
                    valueFromForm={values.location}
                    onChange={value => {
                      form.change('location', value);
                    }}
                    onPlaceSelected={handlePlaceSelect}
                  />
                )}
                {searchType === SearchType.KEYWORDS && (
                  <FieldTextInput
                    type="text"
                    className={css.keywordsInput}
                    id="keywords"
                    name="keywords"
                    placeholder={intl.formatMessage({
                      id: 'LandingSearchForm.keywordsPlaceholder',
                    })}
                  />
                )}
              </>
            ) : null}

            {isMobileLayout ? (
              ' '
            ) : (
              <Button
                className={classNames({
                  [css.searchIcon]: isSearchPageFilter,
                  [css.searchBtn]: !isSearchPageFilter,
                })}
                type="submit"
                inProgress={submitInProgress}
              >
                <IconSearchDesktop />
              </Button>
            )}
            {/* {isMobileLayout ? (
              <div className={css.chooseDateSec}>
                <h2>When?</h2>
                <DatePicker
                  isMobileSeachDatepicker={true}
                  range={true}
                  showMonthStepper={true}
                  onChange={handleChange}
                  isBlockedBetween={isBlockedBetween}
                  value={dateRangeData.dateRange}
                  rangeStartHasValue={dateRangeData.formatted?.[0]?.length > 0}
                  rangeEndHasValue={dateRangeData.formatted?.[1]?.length > 0}
                  {...startDateMaybe}
                  {...rest}
                />
              </div>
            ) : null} */}
          </Form>
        );
      }}
    />
  );
};

LandingSearchFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  onSubmit: func.isRequired,
  intl: intlShape.isRequired,
};

const LandingSearchForm = injectIntl(LandingSearchFormComponent);

export default LandingSearchForm;
